var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProcessReports = function SvgProcessReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -39.44,
    y1: 112.99,
    x2: 105.61,
    y2: -14.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -29.25,
    y1: 124.56,
    x2: 115.81,
    y2: -3.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -19.69,
    y1: 135.41,
    x2: 125.37,
    y2: 7.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.28,
    y1: 159.21,
    x2: 146.34,
    y2: 31.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 7.21,
    y1: 165.94,
    x2: 152.26,
    y2: 38.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 15.41,
    y1: 175.25,
    x2: 160.46,
    y2: 47.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 23.61,
    y1: 184.55,
    x2: 168.66,
    y2: 56.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 25.01,
    y1: 186.15,
    x2: 170.07,
    y2: 58.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 34.67,
    y1: 197.11,
    x2: 179.73,
    y2: 69.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 44.33,
    y1: 208.08,
    x2: 189.38,
    y2: 80.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 30.85,
    y1: 192.78,
    x2: 175.91,
    y2: 64.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 60.06,
    y1: 225.93,
    x2: 205.11,
    y2: 98.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 60.06,
    y1: 225.93,
    x2: 205.11,
    y2: 98.15,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2.94,85.29c1.63,0,2.95-1.32,2.95-2.95V11.74c0-2.88,2.34-5.23,5.23-5.23h120.9c2.89,0,5.23,2.35,5.23,5.23v10.58c0,1.63,1.32,2.94,2.94,2.94s2.95-1.32,2.95-2.94v-10.58c0-6.13-4.99-11.12-11.12-11.12H11.12C4.99.62,0,5.61,0,11.74v70.61C0,83.97,1.32,85.29,2.94,85.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.14,69.01c-1.63,0-2.94,1.32-2.94,2.95v44.02c0,2.71,2.2,4.91,4.91,4.91h12.57c2.71,0,4.91-2.2,4.91-4.91V33.37c0-2.71-2.2-4.91-4.91-4.91h-12.57c-2.71,0-4.91,2.2-4.91,4.91v26.8c0,1.63,1.32,2.95,2.94,2.95s2.94-1.32,2.94-2.95v-25.82h10.6v80.64h-10.6v-43.04c0-1.63-1.32-2.95-2.94-2.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.04,115.97V20.01c0-2.71-2.2-4.91-4.91-4.91h-12.57c-2.71,0-4.91,2.2-4.91,4.91v95.96c0,2.71,2.2,4.91,4.91,4.91h12.57c2.71,0,4.91-2.2,4.91-4.91ZM62.15,114.99h-10.6V20.99h10.6v94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.49,52.66c0-2.71-2.2-4.91-4.91-4.91h-12.57c-2.71,0-4.91,2.2-4.91,4.91v63.32c0,2.71,2.2,4.91,4.91,4.91h12.57c2.71,0,4.91-2.2,4.91-4.91v-63.32ZM91.6,114.99h-10.6v-61.35h10.6v61.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.86,139.45H16c-1.63,0-2.94,1.32-2.94,2.94s1.32,2.95,2.94,2.95h35.86c1.63,0,2.94-1.32,2.94-2.95s-1.32-2.94-2.94-2.94Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M51.86,155.98H16c-1.63,0-2.94,1.32-2.94,2.94s1.32,2.95,2.94,2.95h35.86c1.63,0,2.94-1.32,2.94-2.95s-1.32-2.94-2.94-2.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.86,172.51H16c-1.63,0-2.94,1.32-2.94,2.95s1.32,2.94,2.94,2.94h35.86c1.63,0,2.94-1.32,2.94-2.94s-1.32-2.95-2.94-2.95Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M86.3,139.45h-23.24c-1.63,0-2.95,1.32-2.95,2.94s1.32,2.95,2.95,2.95h23.24c1.63,0,2.95-1.32,2.95-2.95s-1.32-2.94-2.95-2.94Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M60.11,158.92c0,1.63,1.32,2.95,2.95,2.95h29.92c1.63,0,2.95-1.32,2.95-2.95s-1.32-2.94-2.95-2.94h-29.92c-1.63,0-2.95,1.32-2.95,2.94Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.06,178.4h36.6c1.63,0,2.94-1.32,2.94-2.94s-1.32-2.95-2.94-2.95h-36.6c-1.63,0-2.95,1.32-2.95,2.95s1.32,2.94,2.95,2.94Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M197.98,134.28c-.51-2.91-3.3-4.86-6.21-4.35l-11.32,1.99c-.49-.93-1.01-1.85-1.58-2.74l7.39-8.81c.92-1.1,1.36-2.49,1.23-3.92-.12-1.43-.8-2.72-1.89-3.64l-8.55-7.17c-2.27-1.9-5.65-1.6-7.55.66l-7.39,8.81c-.98-.4-1.97-.77-2.98-1.08v-11.49c0-2.96-2.4-5.36-5.36-5.36h-10.63v-63.08c0-1.63-1.32-2.94-2.95-2.94s-2.94,1.32-2.94,2.94v79.94c-1.01.32-2,.68-2.97,1.08l-7.33-8.74v-22.98c0-1.63-1.32-2.94-2.94-2.94s-2.95,1.32-2.95,2.94v21.28c-1.26.43-.99.36-10.26,8.14-.12.1-.23.2-.34.31V31.47h10.6v40.16c0,1.63,1.32,2.94,2.95,2.94s2.94-1.32,2.94-2.94V30.49c0-2.71-2.2-4.91-4.91-4.91h-12.57c-2.71,0-4.91,2.2-4.91,4.91v85.49c0,2.71,2.2,4.91,4.91,4.91h1.08c5.27,6.28,3.74,4.45,6.97,8.31-.57.89-1.1,1.8-1.58,2.74l-11.32-1.99c-2.9-.51-5.69,1.41-6.21,4.35l-1.94,10.98c-.51,2.91,1.44,5.7,4.35,6.21l11.33,2c.14,1.05.32,2.09.55,3.11l-9.95,5.75c-2.56,1.48-3.44,4.76-1.96,7.32l5.58,9.66c1.48,2.56,4.76,3.44,7.32,1.96l9.96-5.75c.78.71,1.58,1.39,2.42,2.03l-3.93,10.81c-.64,1.75-.3,3.62.73,5.02H11.12c-2.89,0-5.23-2.35-5.23-5.23v-94.04c0-1.63-1.32-2.95-2.95-2.95S0,92.5,0,94.13v94.04C0,194.29,4.99,199.28,11.12,199.28h120.9c1.09,0,2.15-.16,3.15-.46,3.81,1.4,6.57-.39,7.51-2.97l3.94-10.81c1.06.05,2.1.05,3.16,0l3.93,10.81c1,2.75,4.05,4.23,6.87,3.21l10.49-3.82c2.78-1.01,4.21-4.09,3.2-6.87l-3.94-10.81c.84-.64,1.64-1.32,2.42-2.03l9.96,5.75c2.56,1.48,5.84.61,7.32-1.96l5.58-9.66c1.48-2.56.6-5.84-1.96-7.32l-9.95-5.75c.23-1.03.41-2.07.55-3.11l11.33-2c2.6-.45,4.43-2.73,4.43-5.28,0-.64.08.02-2.02-11.92ZM177.46,157.21c-.38,1.3.18,2.69,1.35,3.37l11.43,6.59-5.05,8.74c-17.51-10.11-11-7.96-20.04-1.88-1.12.75-1.59,2.18-1.13,3.45l4.52,12.4-9.49,3.45-4.51-12.4c-.46-1.27-1.74-2.07-3.08-1.92-10.91,1.18-7.23-4.66-14.14,14.33l-2.36-.86-7.13-2.59c6.93-19.02,5.92-12.2-1.62-20.07-.94-.97-2.43-1.19-3.6-.51l-11.44,6.6-5.05-8.74,11.43-6.59c1.17-.68,1.73-2.07,1.35-3.37-.61-2.09-.98-4.26-1.13-6.45-.09-1.35-1.09-2.47-2.43-2.71l-13-2.29,1.75-9.94c19.87,3.51,13.05,3.74,19.47-5.08.8-1.1.75-2.6-.12-3.63-.04-.05-5.55-6.61-8.49-10.11,5.52-4.63,3.79-3.17,7.73-6.49,5.08,6.05,3.18,3.79,8.48,10.11.87,1.04,2.34,1.35,3.55.75,1.9-.93,3.98-1.7,6.15-2.23,1.29-.31,2.2-1.46,2.24-2.78,0-.03,0-.05,0-.08v-13.2h10.09v13.2c0,1.35.93,2.54,2.24,2.86,2.12.52,4.19,1.27,6.15,2.23,1.22.6,2.68.29,3.55-.75l8.48-10.11,7.73,6.49-8.48,10.11c-.87,1.04-.92,2.54-.12,3.63,1.29,1.76,2.39,3.67,3.27,5.66.55,1.24,1.87,1.94,3.21,1.71l12.99-2.29,1.75,9.94c-19.95,3.51-13.53,1-16.56,11.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.19,121.88c-14.56,0-26.4,11.85-26.4,26.41s11.85,26.41,26.4,26.41,26.41-11.85,26.41-26.41c0-14.56-11.84-26.41-26.41-26.41ZM148.19,168.8c-11.31,0-20.51-9.2-20.51-20.51s9.2-20.51,20.51-20.51,20.52,9.2,20.52,20.51-9.2,20.51-20.52,20.51Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.39,148.29c0,13.23,16.03,19.7,25.27,10.47,5.78-5.78,5.78-15.15,0-20.93-9.36-9.36-25.27-2.6-25.27,10.47ZM141.89,154.59c-5.56-5.56-1.67-15.21,6.3-15.21,4.93,0,8.91,3.99,8.91,8.91,0,7.86-9.57,11.94-15.21,6.3Z"
  })));
};
export default SvgProcessReports;